import React from "react";


const IconLinkedIn = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 0C4.47714 0 0 4.47714 0 10C0 15.5229 4.47714 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47714 15.5229 0 10 0ZM6.25309 16.7705H3.44184V7.72542H6.25309V16.7705ZM4.84808 6.489C3.94701 6.489 3.2176 5.75857 3.2176 4.85872C3.2178 3.95969 3.94701 3.22926 4.84808 3.22926C5.7467 3.22926 6.47714 3.95969 6.47714 4.85872C6.47714 5.75877 5.7465 6.489 4.84808 6.489ZM16.7822 16.7705H13.9732V12.3718C13.9732 11.3228 13.9538 9.97361 12.5119 9.97361C11.0498 9.97361 10.825 11.1161 10.825 12.2959V16.7703H8.01616V7.72542H10.7124V8.96143H10.7503C11.1257 8.25023 12.0424 7.50056 13.4101 7.50056C16.2568 7.50056 16.7822 9.37391 16.7822 11.8093V16.7705Z"
      fill="white"
    />
  </svg>
);

export default IconLinkedIn;
